/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BudgetDtoPage } from '../../models/budget-dto-page';

export interface ListBudgets$Params {
  projectId?: string | null;
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'projectId' | '-projectId' | 'name' | '-name' | 'description' | '-description' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'project' | '-project' | 'plannedUnitCostsCount' | '-plannedUnitCostsCount' | 'plannedLaborCostsCount' | '-plannedLaborCostsCount' | 'workPackagesCount' | '-workPackagesCount' | 'budgetVersionCount' | '-budgetVersionCount' | 'currentVersionId' | '-currentVersionId' | 'currentVersionBudgetCap' | '-currentVersionBudgetCap' | 'currentVersionState' | '-currentVersionState' | 'currentVersionStartDate' | '-currentVersionStartDate' | 'currentVersionEndDate' | '-currentVersionEndDate'>;
}

export function listBudgets(http: HttpClient, rootUrl: string, params?: ListBudgets$Params, context?: HttpContext): Observable<StrictHttpResponse<BudgetDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listBudgets.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BudgetDtoPage>;
    })
  );
}

listBudgets.PATH = '/v0/budgets';
